
import { updateAppConfig } from '#app'
import { defuFn } from '/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "b28bce97-4a0c-411a-a928-bbcb12d88d4b"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
